export default __webpack_public_path__ + "static/media/grey-dot-single.6312be8d.svg";